import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { ListViewController } from '@commoncore/controller/ListViewController';
import { GlobalService } from '@commoncore/services/global.service';
import { CUT_COPY_OPERATION } from '@commoncore/services/universal.service';
import { ActiveTabUtil } from '@commoncore/utils/ActiveTabUtil';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { moveCopyController } from '@mainrepo/app/core/controller/moveCopyController';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { GenericModule } from '@modules/generic/generic.module';
import { AgGridModule } from 'ag-grid-angular';
import { PopUpTabbedViewComponent } from '../../pop-up-tabbed-view/pop-up-tabbed-view.component';

@Component({
  standalone:true,
  selector: 'app-move-copy',
  templateUrl: './move-copy.component.html',
  styleUrls: ['./move-copy.component.scss'],
  imports:[DependenciesModule,PopUpTabbedViewComponent,GenericModule, AgGridModule]
})
export class MoveCopyComponent implements OnInit {
  @Input() enableButton;
  @Output() close = new EventEmitter();
  @Output() createNewFolder = new EventEmitter();
  @Output() removeFolderKeys = new EventEmitter();
  @Output() fetchNestedFolderData = new EventEmitter();
  @Output() fetchNestedFolderDataForMobile = new EventEmitter();
  @Output() fetchNestedFolderDataForShared = new EventEmitter();
  @Output() fetchNestedFolderDataForMobileShared = new EventEmitter();
  @Output() fetchNestedFolderDataForTeamFolder = new EventEmitter();
  @Output() fetchNestedFolderDataForTeamFolderMobile = new EventEmitter();
  @Output() closecreateModal = new EventEmitter();
  @Output() createFolderValidation = new EventEmitter();
  @Output() gotoPreviousScreen = new EventEmitter();
  @Output() confirmMove = new EventEmitter();
  @Output() confirmCopy = new EventEmitter();
  public modules : any;
  controller: any;
  implRef: any;
  universalService: any;
  listService: any;
  mcController: any;
  maximize : boolean = true;
  listController:any;
  listImplRef:any;
  loggerService: any;
  showNewFolderIcon: boolean = true;
  router:any;
  mcImplRef:any;
  overlayNoRowsTemplate:any;
  activeTabUtil: any;
  tabData:any;
  tabDetails :any;
  selectedTab :any;
  localStorageService:any;
  loadPopUpTabbedView:boolean = false;
  cleverTapEventsService:any;
  showMoveCopyModal : boolean = false;
  enableMoveCopyBtn: boolean = false;
  http:any;
  containerHeightCalc: any;
  sessionStorageService:any;
  constructor(public globalService:GlobalService, private cdRef :ChangeDetectorRef) {
    this.setEnvObjects(globalService);
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
    this.overlayNoRowsTemplate =
      '<span></span>'
   }
   
   @HostListener('document:keydown', ['$event'])
   onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && this.showMoveCopyModal && !this.universalService.showCreateFolderModal) {
      this.listService.deSelectAll(event)
    } else if(event.key === "Enter" && this.showMoveCopyModal){
      if(this.universalService.popUpToBeOpened == 'movePopUp' && this.universalService.objectSelected && !this.listService.createFolderObject){
        this.confirmMoveOperation();
      } else if(this.universalService.popUpToBeOpened == 'copyPopUp' && !this.listService.createFolderObject && this.universalService.objectSelected){
        this.confirmCopyOperation();
      }
    }
  }

  onGridReady(params) {
    this.listService.moveCopyOptions.api = params.api;
  }

  ngOnInit(): void {
    let classRef = this;
    this.loggerService.log("inside move copy component");
    this.controller=FileOperationsController.getInstance(this.globalService);
    this.listController = ListViewController.getInstance(this.globalService);
    this.listImplRef = this.listController.listViewImplementation;
    this.implRef = this.controller.fileOperationsImplementation;
    this.mcController = moveCopyController.getInstance(this.globalService);
    this.mcController.setEnvObjects(this.globalService);
    this.mcImplRef = this.mcController.moveCopyImplementation;

    AppEvents.optionSelected.subscribe(event => {
      console.log("movecopy", event)
      if(event["movecopy"]){
        classRef.showMoveCopyModal = event["movecopy"];
        classRef.initializeComponent();
        // this.maximize = true;
        // this.transformModal();
        this.cdRef.detectChanges();
      }else if(event["moveOutOfPrivateFolder"]){
        classRef.showMoveCopyModal = false;
        classRef.initiateMoveOutOfPrivateFolder();
      } else if(event["confirmMoveToPrivateFolder"]){
        classRef.showMoveCopyModal = false;
        classRef.initiateMoveToPrivateFolder();
      } else if(event["closeAll"] || event["movecopy"]== false){
        classRef.loadPopUpTabbedView = false;
        classRef.showMoveCopyModal = false;
        // this.maximize = true;
        // this.transformModal();
        this.cdRef.detectChanges();
      } else if(event["enableBtn"]== true){
        classRef.enableMoveCopyBtn = true;
      }else if(event["enableBtn"]== false){
        classRef.enableMoveCopyBtn = false;
      } else if(event["pasteFiles"]== true){
        classRef.pasteFiles();
        this.cdRef.detectChanges();
      }
    })
  
  }

 initializeComponent(){
  this.registerEvents();
  if(this.universalService.showPreview && !this.universalService.isMobileDevice && this.universalService.selectedNodes.length == 0)
    this.universalService.selectedNodes.push(this.universalService.selectedFile);
  this.listService.moveCopyOptions.api.setRowData();
  if(this.universalService.currentTab == "PrivateFolder"){
    this.implRef.folderNames = [{"objectName":"Private Folder"}];
    const pfKey = this.localStorageService.getPrivateFolderKey();
    this.implRef.folderKeys = [pfKey];
  }else{
    this.implRef.folderNames = [{"objectName":"All Files"}];
    this.implRef.folderKeys = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]];
  }
  this.calculateHeightForModalMobile();
  this.cdRef.detectChanges();
  // this.transformModal();
  this.listImplRef.changeDetectorRef  = this.cdRef;
  this.mcImplRef.currentTab = "";
  this.enableMoveBtnForNonRootFiles();
  this.checkIfInAppWebViewOpenedForCopy();
  this.cdRef.detectChanges();
  this.decideView();
 }

  enableMoveBtnForNonRootFiles(){
    var rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    if(this.universalService.currentTab == "PrivateFolder"){
      rootFolderKey = this.localStorageService.getPrivateFolderKey();
    }
    const selectFilesParentObjectKey = this.universalService.selectedNodes[0]["FullObject"] ? this.universalService.selectedNodes[0]["FullObject"]["parentObjectKey"] : this.universalService.selectedNodes[0].parentObjectKey;
    this.universalService.objectSelected =  selectFilesParentObjectKey != rootFolderKey ? true : false;
  }

  decideView(){
    var registeredEvents = AppEvents.getRegisteredEvents();
    if(this.universalService.popUpToBeOpened == "copyPopUp"){
      // $('.moveCopyModalContentDesktop #ag-grid').height("280px");
      this.calculateHeightForDesktop()
      var url = window.location.href;
      if(url.includes("sharedwithme")){
        this.mcImplRef.source = "share"
      } else if(url.includes("teamfolder") || url.includes('/search/tf')){
        this.mcImplRef.source = "teamfolder"
      }else{
        this.mcImplRef.source = "repo"
      }
      // setTimeout(() => {
      if(registeredEvents.includes(EventsList.COPY_TABBED_VIEW)){
        AppEvents.emit(EventsList.COPY_TABBED_VIEW);
      }
      // }, 1);
      this.cleverTapEventsService.onShareCopyClick(this.universalService.currentTab);
    }else{
      this.calculateHeightForDesktop()
      // $('.moveCopyModalContentDesktop #ag-grid').height("320px");
      this.mcController.setPayloadAndGetFolders(this.universalService.selectedNodes,this.universalService.currentTab);
    }
  }

  checkIfInAppWebViewOpenedForCopy(){
          var nativeHeaders = this.localStorageService.getNativeHeaders('nativeHeaders');
          if(nativeHeaders){
            this.universalService.userLoggedIn = true;
            this.universalService.inAppWebViewOpened = true;
            var height = window.screen.height;
            $("body").css("height",height);
          }
      }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.router = globalService.getRouterRef();
    this.activeTabUtil = new ActiveTabUtil();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.http = globalService.getHttpClientRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
  }
  closePopUp(){
    if(this.universalService.currentTab == 'copy' && this.universalService.inAppWebViewOpened){
      this.universalService.currentTab = "";
    }
    // this.universalService.removePopUpEventListeners();
    this.listService.noFoldersPresent = false;
    this.close.emit();
    this.showMoveCopyModal = false;
    if(this.router.url == "/favorites/myfiles"){
      var tab = this.universalService.tabClicked;
      jQuery('#'+tab).addClass('active')
    }
  }

  createFolder(){
    setTimeout(()=>{
      let el = document.querySelector('.moveCopyModal') as any;
      if(el){
        let cretaeModal = document.querySelector('.create-folder-modal') as any;
        cretaeModal.classList.add('removeModalOverlay')
        let ele = document.getElementById('custome_backdrop')
        if(ele){
          ele.style.display = 'none';
        }
      }
    },40)
    this.universalService.errorMessage = '';
    this.listService.createFolderObject = true;
    this.createNewFolder.emit();
  }

  switchFolders(){
    this.removeFolderKeys.emit();
  }

  fetchNestedFoldersData(eve){
    console.log("event",eve)
    if(this.mcImplRef.currentTab == "sharedwithme"){
      this.showNewFolderIcon = true;
      this.fetchNestedFolderDataForShared.emit(eve);
    } else if(this.mcImplRef.currentTab == "teamfoldercopy"){
      this.showNewFolderIcon = true;
      this.fetchNestedFolderDataForTeamFolder.emit(eve);
      if(this.universalService.selectedFile && this.universalService.selectedFile.userRight && this.universalService.selectedFile.userRight.canAdd == false) {
        this.showNewFolderIcon = false;
      } else {
        this.showNewFolderIcon = true;
      }
    }else{
      this.fetchNestedFolderData.emit(eve);
    }
    
  }

  fetchNestedFoldersDataForMobile(eve){
    var focusedCell = this.listService.moveCopyOptions.api.getFocusedCell();
    if(focusedCell["column"]["colId"]=="ImagePath"){
      if(this.mcImplRef.currentTab == "sharedwithme"){
        this.showNewFolderIcon = true;
        this.fetchNestedFolderDataForMobileShared.emit(eve);
      }else if(this.mcImplRef.currentTab == "teamfoldercopy"){
        this.showNewFolderIcon = true;
        this.fetchNestedFolderDataForTeamFolderMobile.emit(eve);
        if(eve.data["FullObject"]["userRight"]["canAdd"] == false) {
          this.showNewFolderIcon = false;
        } else {
          this.showNewFolderIcon = true;
        }
      }else{
      this.fetchNestedFolderDataForMobile.emit(eve);
      }
    }

    
  }

  closeCreateModal(){
    this.closecreateModal.emit();
  }

  goBackToPreviousScreen(){
    this.gotoPreviousScreen.emit();
  }

  validateBeforeCreatingFolder(value){
    this.createFolderValidation.emit(value)
  }

  async fetchDataForSelectedFolder(folder){
    this.calculateHeightsForDesktopAndMobile();
    var index = this.implRef.folderNames.indexOf(folder);
    var folderKeyIndex = this.implRef.folderKeys.indexOf(folder["objectKey"]);
    let folderKey;
    const pfKey = this.localStorageService.getPrivateFolderKey();
    if(folder.objectName=='All Files'){
      folderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    }else if(folder.objectName=='Private Folder'){
      folderKey = pfKey;
    }else {
      folderKey = folder.objectKey;
    }
    if(index!=0 && folderKeyIndex!=0){
      if(this.implRef.folderNames.length == index+1){
        this.loggerService.log("already on the same folder");
        return;
      }else{
        this.implRef.folderNames.length = index+1;
        this.implRef.folderKeys.length = folderKeyIndex+1;
        this.universalService.selectedFolder = this.implRef.folderNames[index];
      }
    }else{
      this.implRef.folderKeys = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]];
      if(this.mcImplRef.currentTab == "sharedwithme"){
        this.implRef.folderNames  = [{"objectName":"Shared Files"}];
      } else if(this.mcImplRef.currentTab == "teamfoldercopy"){
        this.implRef.folderNames  = [{"objectName":"Team Folder"}];
      } else if(this.universalService.currentTab == "PrivateFolder"){
        this.implRef.folderNames  = [{"objectName":"Private Folder"}];
        this.implRef.folderKeys = [pfKey];
      } else{
        this.implRef.folderNames  = [{"objectName":"All Files"}];
        this.implRef.folderKeys = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]];
      }
      this.universalService.selectedFolder = undefined;
    }
    if (this.universalService.popUpToBeOpened == "movePopUp") {
      var found = this.universalService.selectedNodes.find(obj=>  {
        const parentObjectKey = obj["parentObjectKey"] ? obj["parentObjectKey"] : obj["FullObject"]["parentObjectKey"];
        return parentObjectKey == folderKey
      });
      const firstFileParentObjectKey = this.universalService.selectedNodes[0].parentObjectKey ? this.universalService.selectedNodes[0].parentObjectKey : this.universalService.selectedNodes[0]["FullObject"].parentObjectKey;
      if((found) ||
        (folder.objectName=='All Files' && firstFileParentObjectKey && firstFileParentObjectKey ==USER_DETAILS["USER_DETAILS"]["rootFolderKey"]) || (folder.objectName=='Private Folder' && firstFileParentObjectKey && firstFileParentObjectKey == pfKey) ) { 
        this.universalService.objectSelected = false;     
      }else{
        this.universalService.objectSelected = true;  
      }
    }
    this.listService.parentFolderKey = this.implRef.folderKeys[this.implRef.folderKeys.length - 1];
    try{ 
      if(this.mcImplRef.currentTab == "sharedwithme"){
        if(folder && folder.objectName && folder.objectName == "Shared Files" ) {
          this.showNewFolderIcon = false;
        }
        await this.controller.getSharedWithMeFolders("%2BobjectName")
      } else if(this.mcImplRef.currentTab == "teamfoldercopy"){
        if(folder && folder.tfName && folder.tfName == "Team Folder" ) {
          this.showNewFolderIcon = false;
        }
        await this.controller.getTeamFolders();
      }else if(this.universalService.currentTab == "PrivateFolder"){
        await this.controller.getPrivateFolders("%2BobjectName");
      }else{
        await this.controller.getFolders("%2BobjectName")
      }
      
    }catch(exc){
      this.loggerService.log("exception handled for move",exc)
    }
  }
  

  confirmMoveOperation(){
    if(this.universalService.listView && this.listImplRef.indexsArray.length>0 && this.implRef.folderNames.length>1)
      this.listImplRef.indexsArray.pop()
    this.universalService.showLoader = true;
    var rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    if(this.universalService.currentTab == "PrivateFolder"){
      rootFolderKey = this.localStorageService.getPrivateFolderKey();
      if(!this.universalService.selectedFolder){ // if private folder root is selected
        this.universalService.selectedFolder = {"objectName":"Private Folder","objectKey":rootFolderKey};
      }
    }
    this.universalService.selectedNodes.map(obj=>{
      if(obj["FullObject"]){
        obj["FullObject"]["parentObjectKey"] = this.universalService.selectedFolder  ? this.universalService.selectedFolder["objectKey"]: rootFolderKey;
      }else{
        obj["parentObjectKey"] = this.universalService.selectedFolder ? this.universalService.selectedFolder["objectKey"] : rootFolderKey;
      }
    })
    var object={
      "files":this.universalService.selectedNodes,
      "operation":"MOVE",
      "correlationId": USER_DETAILS["USER_DETAILS"]["userId"],
      "opType": (this.universalService.selectedFolder && (this.universalService.selectedFolder["objectName"] == "Private Folder" || (this.universalService.currentTab == "PrivateFolder" && this.universalService.selectedFolder["objectName"] == "JioCloud"))) ? "MOVETOPPF" : ""
    }
    if(this.universalService.currentTab == "PrivateFolder"){
      this.cleverTapEventsService.moveWithinPf();
    }
    this.confirmMove.emit(object);
  }
  
  confirmCopyOperation(){
    this.universalService.showLoader = true;
    if(this.mcImplRef.source == 'repo' && this.mcImplRef.destination == 'repo'){
      var object={
        "files":this.universalService.objectsToBeAdded,
        "operation":"COPY",
        "correlationId": USER_DETAILS["USER_DETAILS"]["userId"]
      }
      this.confirmCopy.emit(object);
    } else if(this.mcImplRef.source == 'teamfolder' || this.mcImplRef.destination == 'teamfolder') { // Any TF related operation
      var object={
        "files":this.universalService.objectsToBeAdded,
        "operation":"COPY",
        "correlationId": USER_DETAILS["USER_DETAILS"]["userId"]
      }
      this.confirmCopy.emit(object);
    }else{
      this.mcController.copyToSelectedFolder(this.universalService.selectedNodes);
      if(this.implRef.folderName == ""){
        this.cleverTapEventsService.onShareCopyHereClick(this.universalService.currentTab);
      }
    }
  }

  // transformModal(){
  //   this.maximize = !this.maximize;
  //   if(this.maximize){
  //     $('.moveCopyModal .modal-dialog').removeClass("modal-md");
  //     $('.moveCopyModal .modal-dialog').addClass("modal-lg");
  //     $(".sharingOptions").removeClass("ml-3");
  //     $(".sharingOptions").addClass("ml-5");
  //   }else{
  //     $('.moveCopyModal .modal-dialog').removeClass("modal-lg")
  //     $('.moveCopyModal .modal-dialog').addClass("modal-md");
  //     $(".sharingOptions").removeClass("ml-5");
  //     $(".sharingOptions").addClass("ml-3");
  //   }
  //   if(this.universalService.popUpToBeOpened == "copyPopUp"){
  //     setTimeout(() => {
  //       this.activeTabUtil.setActiveTabForPopUp(this.selectedTab,this.tabDetails)  
  //     }, 300);
      
  //   }
  // }


  onSelectionChanged(event){
    this.listImplRef.onSelectionChanged()
    this.cdRef.detectChanges();
  }

  async switchTabs(tabName){
    this.universalService.objectSelected = false;
    var fnames = [];
    if(this.listService.moveCopyOptions.api){
      this.listService.moveCopyOptions.api.setRowData([]);
    }
    this.calculateHeightsForDesktopAndMobile();
    this.listService.noFoldersPresent = false;
    if(tabName == "myFiles"){
      this.implRef.folderKeys = [USER_DETAILS["USER_DETAILS"]["rootFolderKey"]];
      this.selectedTab = this.tabDetails[0];
      this.mcImplRef.currentTab = ""
      this.showNewFolderIcon = true;
      this.mcImplRef.destination = "repo";
      fnames = await this.mcController.setPayloadAndGetFolders(this.universalService.selectedNodes,"");
    }else if (tabName == "sharedwithme"){
      this.selectedTab = this.tabDetails[1];
      this.mcImplRef.currentTab = tabName
      this.showNewFolderIcon = false;
      this.mcImplRef.destination = "share";
      fnames = await this.mcController.setPayloadAndGetFolders(this.universalService.selectedNodes,"sharedwithme");
    } else if (tabName == "teamfoldercopy") {
      this.selectedTab = this.tabDetails[2];
      this.mcImplRef.currentTab = tabName
      this.showNewFolderIcon = false;
      this.mcImplRef.destination = "teamfolder";
      fnames = await this.mcController.setPayloadAndGetFolders(this.universalService.selectedNodes,"teamfoldercopy");
    }
    this.implRef.folderNames = fnames;
  }

  registerEvents(){
    this.universalService.removePopUpEventListeners();
    this.loadPopUpTabbedView = true;
    let classRef = this;
    console.log("classRef.universalService.PopUpTabClicked",classRef.universalService.PopUpTabClicked)
    AppEvents.on(EventsList.POP_UP_TAB_CLICKED, function(tabDetails){
      classRef.tabDetails = tabDetails;
      classRef.selectedTab = classRef.selectedTab ? classRef.selectedTab : classRef.tabDetails[0];
      console.log("inside pop up tab clicked from move copy component")
      classRef.switchTabs(classRef.universalService.PopUpTabClicked)
    })
    AppEvents.on(EventsList.DECIDE_TO_ENABLE_BUTTON, function(){
      console.log("inside pop up tab clicked from move copy component")
      classRef.decideIfButtonShouldBeEnabled()
    })

    AppEvents.on(EventsList.POPUP_TABBED_VIEW_READY, function(){
      classRef.decideView();
    })
  }

  decideIfButtonShouldBeEnabled(){
    if(this.selectedTab["id"] == 'sharedwithme' && this.implRef.folderNames.length == 1 && this.implRef.folderNames[0]["objectName"] == "Shared Files"){
      this.universalService.objectSelected = false;
    } else if(this.selectedTab["id"] == 'teamfoldercopy' && this.implRef.folderNames.length == 1 && this.implRef.folderNames[0]["objectName"] == "Team Folder"){
      this.universalService.objectSelected = false;
    }else{
      this.universalService.objectSelected = true;
    }
    return;
  }

  calculateHeightForModalMobile(){
    if(this.universalService.isMobileDevice){
      setTimeout(() => {
        var headerHeight = this.universalService.inAppWebViewOpened?$('.webview-header').innerHeight():$('.move-copy-header').innerHeight()
        this.containerHeightCalc.calculateHeight('', ['.folderNav','.popup-nav-tabs','.move-copy-footer'], 10+headerHeight)
      }, 800);  
    }
  }

  calculateHeightForDesktop(){
    if(!this.universalService.isMobileDevice){
      setTimeout(() => {
        var headerHeight = $('.slidemenu-modal').is(":visible") ? $('.slidemenu-modal').innerHeight() + $('.move-copy-header').innerHeight() +18: $('.move-copy-header').innerHeight() +12
        $('.addtoJioCloud ag-grid-angular').height($('.moveCopyModal .modal-content').innerHeight() - (headerHeight +$('.move-copy-footer').innerHeight()+ $('.folderNav').innerHeight()))
      }, 800);  
    }else{
      setTimeout(() => {
        var headerHeight = $('.slidemenu-modal').is(":visible") ? $('.slidemenu-modal').innerHeight(): 0
        $('.addtoJioCloud ag-grid-angular').height($('.moveCopyModal .modal-content').innerHeight() - (headerHeight +$('.move-copy-footer').innerHeight()+ $('.folderNav').innerHeight()))
      }, 800); 
    }
  }

  async pasteFiles() {
    var currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
    if(currentFolderKey == undefined || currentFolderKey == ""){//root scenario
      currentFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
    }
    const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
    this.mcImplRef.source = this.universalService.cutCopiedFilesWithKeyboardSource;
    this.mcImplRef.destination = this.universalService.cutCopiedFilesWithKeyboardDestination;
    this.implRef.setRequiredDataForAdding(this.universalService.cutCopiedFilesWithKeyboard);
    if(this.universalService.cutCopiedFilesWithKeyboardDestination == "share") {
      var sharedFolderDetails = this.localStorageService.getSharedFolder(true);
      this.universalService.selectedNodes = this.universalService.cutCopiedFilesWithKeyboard;
      this.universalService.selectedFolder = sharedFolderDetails;
    } else if(this.universalService.cutCopiedFilesWithKeyboardDestination == "repo") {
      this.universalService.selectedFolder = {
        objectKey: currentFolderKey
      };
    }
    if(this.universalService.cutOrCopyOperationType == CUT_COPY_OPERATION.COPY) {
      this.universalService.popUpToBeOpened = "copyPopUp";
      this.confirmCopyOperation();
    } else if(this.universalService.cutOrCopyOperationType == CUT_COPY_OPERATION.MOVE) {
      this.universalService.selectedNodes = this.universalService.cutCopiedFilesWithKeyboard;
      if((currentFolderKey == "" && this.universalService.selectedNodes[0].parentObjectKey == rootFolderKey) || (currentFolderKey != "" && this.universalService.selectedNodes[0].parentObjectKey == currentFolderKey)) {
        this.universalService.showToast(TOAST["CUT_PASTE_ALREADY_EXISTS"], "error");
      } else {
        this.universalService.popUpToBeOpened = "movePopUp";
        await this.confirmMoveOperation();
      }
    }
  }
  calculateHeightsForDesktopAndMobile(){
    this.calculateHeightForDesktop();
  }

  async initiateMoveOutOfPrivateFolder(){
    this.universalService.selectedFolder = {"objectName":"JioAICloud","objectKey":USER_DETAILS["USER_DETAILS"]["rootFolderKey"]};
    this.universalService.isPrivateFolderTokenRequired = true;
    this.confirmMoveOperation();
  }


  async initiateMoveToPrivateFolder(){
    var pfKey = this.localStorageService.getPrivateFolderKey();
    this.universalService.isPrivateFolderTokenRequired = true;
    await this.listService.getPPFToken();    
    this.universalService.selectedFolder = {"objectName":"Private Folder","objectKey":pfKey};
    this.confirmMoveOperation();
  }
  
}
